import React from 'react';
import { Typography, Box, Paper, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="90vh">
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: '16px' }}>
                    <Typography variant="h4" gutterBottom>
                        Access Denied
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        You do not have the required permissions to view this page.
                    </Typography>
                    <Button variant="contained" onClick={() => navigate('/')}>
                        Go to Dashboard
                    </Button>
                </Paper>
            </Box>
        </Container>
    );
};

export default AccessDenied;
